<template>
    <div>
        <v-dialog
            v-model="display"
            width="350"
            persistent>
            <v-card flat>
                <v-card-title>{{ $t('print') }}</v-card-title>
                <v-card-text v-if="loading.data">
                    {{ $t('print_msg_journal') }}
                    <div id="printJournalEntry" style="display: none" >
                        <div>
                            <div class="row">
                                <div class="col-sm">  
                                    <div>
                                        <h4 class="text-left">Petra Ready Mixed Concrete</h4>
                                        <h4 class="text-left"><b>Accounting Department</b></h4>
                                        <h4 class="text-left">Journal Voucher</h4>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm"> 
                                    <div v-if="journalEntry" class="text-center">
                                        <h3>
                                            <b>{{ this.$t('sales_order_number') }} {{journalEntry.code}}</b>
                                        </h3>
                                    </div>
                                </div>
                            </div>
                            <br>
                            <div class="row">
                                <div v-if="journalEntry" class="col-sm">
                                    <h5 class="text-left">{{ $t('title_info') }} :</h5>
                                    <table style="border-collapse: collapse; border: none;" class="table table-bordered table-sm">
                                        <tbody>
                                            <tr>
                                                <th>{{$t('date')}} :</th>
                                                <td>{{ journalEntry.journal_date }}</td>
                                                <th>{{$t('document_date')}} : </th>
                                                <td>{{ journalEntry.document_date }}</td>
                                                <th v-if="journalEntry.is_posted">{{$t('posted_at')}} : </th>
                                                <td v-if="journalEntry.is_posted">{{ journalEntry.posted_at }}</td>
                                            </tr>
                                            <tr>
                                                <th> {{ $t('code') }}</th>
                                                <td>{{ journalEntry.code }}</td>
                                                <th>{{ $t('status') }} :</th>
                                                <td>{{ journalEntry.status }}</td>
                                                <th :colspan="journalEntry.is_reversed ? 0 : 5"> 
                                                    <span  v-if="journalEntry.is_reversed">
                                                        {{ $t('reverse_at') }} :
                                                    </span>
                                                </th>
                                                <td v-if="journalEntry.reversed_at"> {{ journalEntry.reversed_at }}</td>
                                            </tr>
                                            <tr>
                                                <th>{{$t('reference')}} :</th>
                                                <td colspan="5">{{ journalEntry.reference }}</td>
                                               
                                                <!-- <th></th>
                                                <td></td> -->
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div v-if="journalEntry" class="row">
                                <div class="col-sm">
                                    <table class="table table-bordered table-sm" style="font-size:14px">
                                        <thead>
                                            <tr>
                                                <th>{{ $t('account') }}</th>
                                                <th>{{ $t('remark') }}</th>
                                                <th>{{ $t('debit') }}</th>
                                                <th>{{ $t('credit') }}</th>
                                                <th>{{ $t('debit') }} (FC)</th>
                                                <th>{{ $t('credit') }} (FC)</th>
                                                <th>{{ $t('dimension') }}</th>
                                                <th>Rate Calculation</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(journalLine, index) in journalEntry.lines" :key="index">
                                                <td width="250" :style="isArabic(journalLine.account) ? 'text-align: right;': ''">{{ journalLine.account }}</td>
                                                <td width="400" :style="isArabic(journalLine.narration) ? 'text-align: right;': ''">{{ journalLine.narration }}</td>
                                                <td width="140">{{ journalLine.base_debit > 0 ? formatMoney(journalLine.base_debit, journalEntry.baseCurrency, round) : null }}</td>
                                                <td width="140">{{ journalLine.base_credit > 0 ? formatMoney(journalLine.base_credit, journalEntry.baseCurrency, round) : null }}</td>
                                                <td width="140">{{ journalLine.trans_debit > 0 ? formatMoney(journalLine.trans_debit, journalEntry.currency, round) : null }}</td>
                                                <td width="140">{{ journalLine.trans_credit > 0 ? formatMoney(journalLine.trans_credit, journalEntry.currency, round) : null }}</td>
                                                <td width="230">{{ journalLine.dimension }}</td>
                                                <td width="230">{{ journalLine.rateCalculation }}</td>
                                            </tr>
                                            <tr style="border: none;">
                                                <td style="border: none;"></td>
                                                <th style="border: none;">{{ this.$t('total') }}</th>
                                                <th style="border: none;">{{ formatNumber(totalBaseDebit, 2) }}</th>
                                                <th style="border: none;">{{ formatNumber(totalBaseCredit, 2) }}</th>
                                                <th style="border: none;">{{ formatNumber(totalTransDebit, 2) }}</th>
                                                <th style="border: none;">{{ formatNumber(totalTransCredit, 2) }}</th>
                                                <td style="border: none;"></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div v-if="journalEntry" class="row">
                                <div class="col-sm">
                                    <table class="table table-bordered table-sm">
                                        <tbody>
                                            <tr>
                                                <th style="width:12%">{{ $t('created_by') }}:</th>
                                                <td>{{ journalEntry.created_by }}</td>
                                                <td style="display: none"></td>
                                                <td style="display: none"></td>
                                            </tr>
                                            <tr v-if="journalEntry.is_posted">
                                                <th style="width:12%">{{ $t('posted_by') }}:</th>
                                                <td>{{ journalEntry.posted_by }}</td>
                                                <td style="display: none"></td>
                                                <td style="display: none"></td>
                                            </tr>
                                            <tr v-if="journalEntry.is_reversed">
                                                <th style="width:12%">{{ $t('reverse_by') }}:</th>
                                                <td>{{ journalEntry.reversed_by }}</td>
                                                <td style="display: none"></td>
                                                <td style="display: none"></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-btn @click="print" text>
                        {{ $t('print') }}
                    </v-btn>
                    <v-btn @click="close" text>
                        {{ $t('close_btn') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import { formatMoney, formatNumber } from 'accounting';
import isArabic from '@/utils/isArabic';
export default {
    name: "JournalEntryPrintDialog",
    components: {},
    props: {
        journalEntry: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            round: 2,
            display: true,
            openParams: null,
            loading: {
                data: true
            }
        }
    },
    computed: {
        totalBaseDebit() {
            return this.journalEntry.lines.reduce((a, line) =>  a + line.base_debit /1, 0)
        },
        totalBaseCredit() {
            return this.journalEntry.lines.reduce((a, line) =>  a + line.base_credit /1, 0)
        },
        totalTransDebit() {
            return this.journalEntry.lines.reduce((a, line) =>  a + line.trans_debit /1, 0)
        },
        totalTransCredit() {
            return this.journalEntry.lines.reduce((a, line) =>  a + line.trans_credit /1, 0)
        }
    },
    methods: {
        formatMoney,
        formatNumber,
        isArabic,
        // formatMoney(amount) {
        //     return formatMoney(amount, this.journalEntry.currency+' ' , 2);
        // },
        close() {
           this.$emit('close');
        },
        print() {
            this.$htmlToPaper("printJournalEntry");
            this.close();
        }
       
    },
    created() {
       
    }
}
</script>